// extracted by mini-css-extract-plugin
module.exports = {"root":"k_M","leadMediaThumb":"k_4","title":"k_S","excerpt":"k_5"};